import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../translations/lang/en-US.json';

export function Invalid(props, context) {
  return (
    <div className="aligner">
      <div className="centerAligner">
        <Row>
          <Col md={12}>
            <div className="errorIcon" />
          </Col>
          <Col md={12}>
            <p className="font">
              <i className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
              {props.message ? props.message : (<span><FormattedMessage id="somethingWentWrong" defaultMessage={defaultMsg.somethingWentWrong} />
                <FormattedMessage id="pleaseTryTo" defaultMessage={defaultMsg.pleaseTryTo} />
                <a
                  className="cursor"
                  onClick={() => window.location.reload(true)}
                >
                  <FormattedMessage id="reloadAgain" defaultMessage={defaultMsg.reloadAgain} />
                </a></span>)}
                
            </p>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Invalid;



// WEBPACK FOOTER //
// ./src/views/common/invalid.jsx